export default __webpack_public_path__ + "static/cp-big-picture-3b7f28c0fd6a0a0f02d6ad617daaac26.mp4";